(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["split-hero-text-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function ensureAttrs(v) {
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('autoplay');
      v.preload = 'metadata';
    }

    // YENİ: Poster yoksa ilk kareyi göster
    function ensureFirstFrameShown(video){
      // Eğer poster varsa, işimiz yok
      if (video.getAttribute('poster')) return;

      // Metadata yüklendiyse küçük bir offset’e seek et
      const seekTo = 0.12; // 0.1–0.3 sn arası siyah frame kaçırmak için
      const trySeek = () => {
        // Bazı iOS sürümleri otomatik seek’i geciktirebilir
        try {
          if (video.readyState >= 1) {
            // readyState>=1 => metadata var
            // Yalnızca henüz başlamadıysa
            if (video.currentTime < seekTo + 0.01) {
              video.currentTime = seekTo;
            }
          }
        } catch(_) {}
      };

      const onSeeked = () => {
        // Play’e basılmadan önce o kareyi göster
        video.pause();
      };

      // Zaten hazırsa hemen dene
      if (video.readyState >= 1) {
        trySeek();
      } else {
        video.addEventListener('loadedmetadata', trySeek, { once: true });
      }
      video.addEventListener('seeked', onSeeked, { once: true });
    }

    function boot(sectionEl) {
      const media = sectionEl.querySelector('.bb-split-hero__media');
      if (!media) return;
      if (media.__bbInit) return;
      media.__bbInit = true;

      const btn = media.querySelector('.bb-video-play');
      const video = media.querySelector('video.bb-split-hero__video') || media.querySelector('video');
      if (!btn || !video) return;

      if (!video.getAttribute('src')) {
        const s = video.querySelector('source[src]');
        if (s) video.setAttribute('src', s.getAttribute('src'));
      }

      ensureAttrs(video);

      // YENİ: poster yoksa ilk kare fallback
      ensureFirstFrameShown(video);

      const tryPlay = (e) => {
        if (e) e.stopPropagation();
        ensureAttrs(video);
        video.setAttribute('controls', '');
        const p = video.play();
        if (p && typeof p.then === 'function') {
          p.then(() => btn.classList.add('is-hidden')).catch(() => btn.classList.remove('is-hidden'));
        } else {
          btn.classList.add('is-hidden');
        }
      };

      btn.addEventListener('click', tryPlay);

      video.addEventListener('pause', () => {
        if (video.currentTime < (video.duration || 1e9)) {
          btn.classList.remove('is-hidden');
        }
      });

      video.addEventListener('ended', () => {
        btn.classList.remove('is-hidden');
        video.removeAttribute('controls');
        try { video.currentTime = 0; } catch (_) {}
        // Bittiğinde yine ilk kareyi göster
        ensureFirstFrameShown(video);
      });

      const showBtn = () => btn.classList.remove('is-hidden');
      if (video.readyState >= 1) {
        showBtn();
      } else {
        video.addEventListener('loadedmetadata', showBtn, { once: true });
        video.addEventListener('canplay', showBtn, { once: true });
      }
    }

    const section =
      document.getElementById('shopify-section-{{ section.id }}') ||
      document.currentScript.closest('.shopify-section') ||
      document;

    boot(section);

    document.addEventListener('shopify:section:load', (e) => {
      if (e.detail && e.detail.sectionId === '{{ section.id }}') {
        const el = document.getElementById('shopify-section-{{ section.id }}');
        if (el) boot(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
